import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type Promotion = {
  promotion_id?: number; // 프로모션 idx
  promotion_name?: string; // 프로모션 명
  promotion_description?: string; // 프로모션 설명
  promotion_state_date?: number; // 프로모션 시작일
  promotion_end_date?: number; // 프로모션 종료일
  minimum_num?: number; // 최소수량
  promotion_content?: string; // 내용
  promotion_code?: string; // 프로모션 코드
  examination_status?: string; // 심사여부
  is_show?: string; // 노출여부
  is_coupon_issue?: string; // 쿠폰 발행 여부
  is_use_point?: string; // 포인트 사용 여부
  is_use_coupon?: string; // 쿠폰 사용 여부
  possible_channel?: { [key: string]: string | number }; // 사용 가능 채널
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};
export type MapCreatePromotionRequest = {
  group_product: Promotion;
  product_policy: {
    policy_type: 'PROMOTION';
    discount_rate: number;
    reserve_rate: number;
    discount_type: 'W' | 'R';
    reserve_type: 'W' | 'R';
    commission_rate: number;
    commission_type: number;
    share_ratio: number;
    is_show: 'Y' | 'N';
  };
  product_ids: { product_id: number }[];
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Promotion
   * --
   */
  getPromotions: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_PROMOTION, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GETS] Promotion
   * --
   */
  getPromotionsMapping: async (params?: { [key: string]: string | number }) =>
    $http.get(APIConstant.GET_PROMOTIONS_MAPPING, params),

  /**
   * [GET] Promotion
   * --
   */
  getPromotion: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_PROMOTION, {
        promotion_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Promotion
   * --
   */
  createPromotion: async (body: Promotion) => {
    try {
      const res = await $http.post(APIConstant.CREATE_PROMOTION, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Promotion
   * --
   */
  updatePromotion: async (body: Promotion) => {
    try {
      const { promotion_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_PROMOTION, {
        promotion_id: promotion_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Promotion
   * --
   */
  deletePromotion: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_PROMOTION, {
        promotion_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [UPSERT] Promotion
   * --
   */
  upsertPromotion: async (body: Promotion[]) => {
    try {
      const res = await $http.bulk(
        APIConstant.BULK_UPSERT_PROMOTION,
        body,
        'PUT'
      );

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Promotion
   * --
   */
  mapCreatePromotion: async (body: MapCreatePromotionRequest) => {
    try {
      const res = await $http.post(APIConstant.MAP_CREATE_PROMOTION, body);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
